var schemaDefinition = {
    $schema: 'http://json-schema.org/draft-04/schema#',
    title: 'Project Config JSON Schema',
    type: 'object',
    properties: {
        projectId: {
            type: 'string',
            required: true,
        },
        accountId: {
            type: 'string',
            required: true,
        },
        groups: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string',
                        required: true,
                    },
                    policy: {
                        type: 'string',
                        required: true,
                    },
                    trafficAllocation: {
                        type: 'array',
                        items: {
                            type: 'object',
                            properties: {
                                entityId: {
                                    type: 'string',
                                    required: true,
                                },
                                endOfRange: {
                                    type: 'integer',
                                    required: true,
                                },
                            },
                        },
                        required: true,
                    },
                    experiments: {
                        type: 'array',
                        items: {
                            type: 'object',
                            properties: {
                                id: {
                                    type: 'string',
                                    required: true,
                                },
                                key: {
                                    type: 'string',
                                    required: true,
                                },
                                status: {
                                    type: 'string',
                                    required: true,
                                },
                                layerId: {
                                    type: 'string',
                                    required: true,
                                },
                                variations: {
                                    type: 'array',
                                    items: {
                                        type: 'object',
                                        properties: {
                                            id: {
                                                type: 'string',
                                                required: true,
                                            },
                                            key: {
                                                type: 'string',
                                                required: true,
                                            },
                                        },
                                    },
                                    required: true,
                                },
                                trafficAllocation: {
                                    type: 'array',
                                    items: {
                                        type: 'object',
                                        properties: {
                                            entityId: {
                                                type: 'string',
                                                required: true,
                                            },
                                            endOfRange: {
                                                type: 'integer',
                                                required: true,
                                            },
                                        },
                                    },
                                    required: true,
                                },
                                audienceIds: {
                                    type: 'array',
                                    items: {
                                        type: 'string',
                                    },
                                    required: true,
                                },
                                forcedVariations: {
                                    type: 'object',
                                    required: true,
                                },
                            },
                        },
                        required: true,
                    },
                },
            },
            required: true,
        },
        experiments: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string',
                        required: true,
                    },
                    key: {
                        type: 'string',
                        required: true,
                    },
                    status: {
                        type: 'string',
                        required: true,
                    },
                    layerId: {
                        type: 'string',
                        required: true,
                    },
                    variations: {
                        type: 'array',
                        items: {
                            type: 'object',
                            properties: {
                                id: {
                                    type: 'string',
                                    required: true,
                                },
                                key: {
                                    type: 'string',
                                    required: true,
                                },
                            },
                        },
                        required: true,
                    },
                    trafficAllocation: {
                        type: 'array',
                        items: {
                            type: 'object',
                            properties: {
                                entityId: {
                                    type: 'string',
                                    required: true,
                                },
                                endOfRange: {
                                    type: 'integer',
                                    required: true,
                                },
                            },
                        },
                        required: true,
                    },
                    audienceIds: {
                        type: 'array',
                        items: {
                            type: 'string',
                        },
                        required: true,
                    },
                    forcedVariations: {
                        type: 'object',
                        required: true,
                    },
                    cmab: {
                        type: 'object',
                        required: false,
                        properties: {
                            attributes: {
                                type: 'array',
                                items: {
                                    type: 'string',
                                },
                                required: true,
                            }
                        }
                    }
                },
            },
            required: true,
        },
        events: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    key: {
                        type: 'string',
                        required: true,
                    },
                    experimentIds: {
                        type: 'array',
                        items: {
                            type: 'string',
                            required: true,
                        },
                    },
                    id: {
                        type: 'string',
                        required: true,
                    },
                },
            },
            required: true,
        },
        audiences: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string',
                        required: true,
                    },
                    name: {
                        type: 'string',
                        required: true,
                    },
                    conditions: {
                        type: 'string',
                        required: true,
                    },
                },
            },
            required: true,
        },
        attributes: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string',
                        required: true,
                    },
                    key: {
                        type: 'string',
                        required: true,
                    },
                },
            },
            required: true,
        },
        version: {
            type: 'string',
            required: true,
        },
        revision: {
            type: 'string',
            required: true,
        },
        integrations: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    key: {
                        type: 'string',
                        required: true
                    },
                    host: {
                        type: 'string'
                    },
                    publicKey: {
                        type: 'string'
                    },
                    pixelUrl: {
                        type: 'string'
                    },
                },
            },
        },
    },
};
const schema = schemaDefinition;
export default schema;
export const __platforms = ['__universal__'];
//# sourceMappingURL=project_config_schema.js.map